import moment from "moment";

export default function generateFileName(documentMeta) {

  let fileType = getFileType(documentMeta);
  let fileName = createFileName(documentMeta);

  return (fileName + fileType).toUpperCase();
}

function getFileType(documentMeta) {
  documentMeta.fileType = documentMeta.fileType || '.unkw';
  return documentMeta.fileType.includes(".") ? documentMeta.fileType : '.' + documentMeta.fileType;
}

function createFileName(documentMeta) {
  
  let { title, regNr, signDate } = documentMeta;
  const numbOfChars = 50;
  const attachment = extractAttachment(documentMeta);

  title = removeAttachmentFromTitle(title, attachment);
  title = truncateTitle(title, numbOfChars);
  regNr = sanitizeRegNr(regNr);
  signDate = formatSignDate(signDate);

  return 'Nr. ' + regNr + ' ' + signDate + ' ' + title + '... ' + attachment;
}

function extractAttachment(documentMeta) {

  if (documentMeta.name.toLowerCase() !== 'priedas') { 
    return "";
  }

  let matches = documentMeta.title.match(/\(?\d*[a-z]*\s*priedas\)?/gi);

  if (matches) {

    var lastMatch = matches[matches.length - 1];
    if (documentMeta.title.endsWith(lastMatch)) {
      return `(${lastMatch.replace(/\(|\)/g, "")})`;
    }
  }
  return '(priedas)';
}

function removeAttachmentFromTitle(title, attachment) {

  if (attachment && title.endsWith(attachment)) {
    title = title.slice(0, title.length - attachment.length)
  }
  return title;
}

function truncateTitle(title, numbOfChars) {
  return title.slice(0, numbOfChars);
}

function sanitizeRegNr(regNr) {
  return (regNr || '').replace(/[<>:"/\\|?*]/g, '');
}

function formatSignDate(signDate) {
  let date = signDate || ''

  if (moment(date).isValid()) date = moment(date).format("YYYY-MM-DD");

  return date;
}